var cilDoubleQuoteSansRight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M280,185.143V416H496V16H457.6ZM464,384H312V198.857L464,54.1Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M232,16H193.6L16,185.143V416H232ZM200,384H48V198.857L200,54.1Z' class='ci-primary'/>"];

export { cilDoubleQuoteSansRight };

